import { Portal } from '@talos/kyoko';
import type { PropsWithChildren } from 'react';

export const TAB_BAR_ACCESSORIES_PORTAL_ID = 'tab-bar-accessories-portal';

export function TabBarAccessories({ children }: PropsWithChildren) {
  return <Portal portalId={TAB_BAR_ACCESSORIES_PORTAL_ID}>{children}</Portal>;
}
